export default "__VITE_ASSET__cf0840a2__"